import React from "react"
import { useSelector } from "react-redux"

import CheckboxDeliveryServiceInternal from "./CheckboxDeliveryServiceInternal"
import CheckboxDeliveryServiceSnapbox from "./CheckboxDeliveryServiceSnapbox"
import classes from "./CheckoutDeliveryServices.module.scss"

const CheckoutDeliveryServices = props => {
  const {
    isSnapboxOutOfService,
    snapboxQuotaionLoading,
    internalDeliveryFee,
    setInternalDeliveryFee,
    snapboxDeliveryFee,
    snapboxDeliveryCategories,
    selectedSnapboxDeliveryCategory,
    setSelectedSnapboxDeliveryCategory
  } = props

  const { websiteFeatures } =
    useSelector(state => state.systemSettings)

  const selectedCashierBranch =
    useSelector(state =>
      state.userAccountInfo.selectedCashierBranch
    )

  const internalDeliveryEnabled =
    websiteFeatures.internalDeliveryService

  return (
    <div className={classes["container"]}>
      {
        internalDeliveryEnabled &&
        <CheckboxDeliveryServiceInternal
          internalDeliveryFee={internalDeliveryFee}
          setInternalDeliveryFee={setInternalDeliveryFee}
        />
      }
      {
        selectedCashierBranch.snappboxFlag &&
        <CheckboxDeliveryServiceSnapbox
          snapboxDeliveryFee={snapboxDeliveryFee}
          snapboxQuotaionLoading={snapboxQuotaionLoading}
          isSnapboxOutOfService={isSnapboxOutOfService}
          snapboxDeliveryCategories={snapboxDeliveryCategories}
          selectedSnapboxDeliveryCategory={selectedSnapboxDeliveryCategory}
          setSelectedSnapboxDeliveryCategory={setSelectedSnapboxDeliveryCategory}
        />
      }
    </div>
  )
}

export default React.memo(CheckoutDeliveryServices)